<template lang="pug">
    v-container
      v-card.elevation-12
        v-toolbar(dark color='#ed1b24' flat)
          v-toolbar-title i-Permit Login
        v-card-text
          v-form
            v-text-field(v-model='username' prepend-icon='person' label='iSafe ID e.g B1A2D3 or C4D5EE' type='email' @keyup.enter='login')
            v-text-field(v-model='password' prepend-icon='lock' label='iSafe Password' type='password' @keyup.enter='login')
        v-card-actions
          div.pa-2
            router-link(
              :to="{ name: 'Faq' }"
              style="text-decoration: none;"
            ) Butuh bantuan?
          v-spacer
          v-btn(dark color='#ed1b24' @click='login' :loading='loadingData') Login
      v-snackbar(v-model='snackbar' color='error' :timeout='6000') {{ errormsg }}
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoginCard",
  data: () => ({
    username: "",
    password: "",
    snackbar: false,
    errormsg: "Authentication Failed"
  }),
  computed: {
    ...mapState(["loadingData", "showDrawer"])
  },
  mounted() {
    this.username = this.$route.query.email || '';
    this.$store.state.loadingData = false;
    this.$store.state.loader = false;
  },
  methods: {
    login() {
      const { username, password } = this;
      this.$store.dispatch("login", { username, password })
      .then(user => {
        if (this.showDrawer) this.$store.commit("toggleDrawer");
        if (user && this.showDrawer) this.$store.commit("toggleDrawer");
        if (this.$route.query.r) return this.$router.push(this.$route.query.r);

        if (user.group_level.includes("PIC")) return this.$router.push("my-permit");
        else if (user.group_level.includes("WASKAT")) return this.$router.push("my-approval-list");

        return this.$router.push("/my-approval-list"); 
      })
      .catch(message => this.showError(message));
    },
    showError(message) {
      this.errormsg = message;
      this.snackbar = true;
    }
  }
};
</script>
